import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Box } from '@mui/material';
import { EmailFillNotice } from 'entities/email/ui/fill-notice';
import { EmailConfirmNotice } from 'entities/email/ui/confirm-notice';
import { AclSuggestions } from 'entities/device.acl.suggestion/ui';
import { TrustPhonesNotice } from 'entities/device.trust-phones/ui/notice';
import { AclRequests } from 'entities/device.acl.request/ui';
import { UpdateVersionSuggestion } from 'entities/user.update_app/ui';
import { UpdateDeviceFirmwareRequests } from 'entities/device.service.upgrades/ui';
import { UpdateDeviceAccessoriesFirmwareRequests } from 'entities/device.service.accessories.upgrade/ui';
export const CornerNotifications = memo(function CornerNotificationsImpl() {
    return (_jsxs(Box, { position: "fixed", zIndex: 50, bottom: 70, right: 10, left: 10, display: "flex", flexDirection: "column", rowGap: 2, maxWidth: 425, marginLeft: "auto", children: [_jsx(UpdateVersionSuggestion, {}), _jsx(AclSuggestions, {}), _jsx(AclRequests, {}), _jsx(EmailFillNotice, {}), _jsx(EmailConfirmNotice, {}), _jsx(TrustPhonesNotice, {}), _jsx(UpdateDeviceFirmwareRequests, {}), _jsx(UpdateDeviceAccessoriesFirmwareRequests, {})] }));
});
